module.exports = __webpack_public_path__ + "static/img/guoyao-logo2.258c19a8.png";